import { getPastOrdersApi } from "../../../api/get/getPastOrdersApi";
import { getCateringPastOrdersApi } from "../../../api/get/getCateringPastOrdersApi";
import { getCateringOrderDetailsApi } from "../../../api/get/getCateringOrderDetailsApi";
import { createCustomer } from "../../../api/post/createCustomerApi";
import { searchCustomer } from "../../../api/post/searchCustomerApi";
import { updateCustomer } from "../../../api/post/updateCustomerApi";
import { clearAllCateringData } from "../restaurants/restaurantSlice";
import { setCreatedCustomer, setPastOrders, setSearchedCustomer, setActiveOrders, setCateringPastOrders, setCateringOrderDetails } from "./cateringCustomerSlice";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const createCateringCustomerAsync = (customerData) => async (dispatch) => {
  try {
    const response = await createCustomer(customerData);
    // Extract just the data object from the API response
    const customerDataOnly = response.data || response;
    dispatch(setCreatedCustomer(customerDataOnly));
    return { success: true, data: customerDataOnly };
  } catch (error) {
    console.error("Catering customer creation failed:", error);
    return { 
      success: false, 
      error: error.response?.data || { message: 'Failed to create customer' } 
    };
  }
};

export const searchCateringCustomerAsync = (mobileCountryCode, mobileNo) => async (dispatch) => {
  try {
    const customerData = await searchCustomer(mobileCountryCode, mobileNo);
    
    // Check if customer was found
    if (customerData && customerData.id) {
      dispatch(setSearchedCustomer({...customerData, service_type: "individual catering"}));
    } else {
      // No customer found - set searchedCustomer to null but isUserSearched to true
      // This will trigger the CreateAccount component to show
      dispatch(setSearchedCustomer(null));
    }
    
    // Clear catering data when new customer is searched
    dispatch(clearAllCateringData());
  } catch (error) {
    console.error("Catering customer search failed:", error);
    // On error (like 404), also set to null to show CreateAccount
    dispatch(setSearchedCustomer(null));
  }
};

export const cateringCustomerPastOrdersAsync = (customerId) => async (dispatch) => {
  try {
    const pastOrders = await getPastOrdersApi(customerId);
    // Dispatch all orders as past orders
    dispatch(setPastOrders(pastOrders.data));
    // The setActiveOrders reducer will handle the filtering and field selection
    dispatch(setActiveOrders(pastOrders.data));
    
  } catch (error) {
    console.error("Catering customer past order search failed:", error);
  }
};

export const getCateringPastOrdersAsync = (customerId, customerType = "individual", companyId = "") => async (dispatch) => {
  try {
    const pastOrders = await getCateringPastOrdersApi(customerId, customerType, companyId);
    dispatch(setCateringPastOrders(pastOrders.data));
  } catch (error) {
    console.error("Get catering past orders failed:", error);
  }
};

export const getCateringOrderDetailsAsync = (orderId) => async (dispatch) => {
  try {
    const orderDetails = await getCateringOrderDetailsApi(orderId);
    dispatch(setCateringOrderDetails(orderDetails.data));
  } catch (error) {
    console.error("Get catering order details failed:", error);
  }
};

export const updateCateringCustomerAsync = createAsyncThunk(
  "cateringCustomer/updateCustomer",
  async (customerData, { dispatch, rejectWithValue }) => {
    try {
      const response = await updateCustomer(customerData);
      
      if (response.success) {
        // Re-fetch customer data to update the state with latest info
        await dispatch(searchCateringCustomerAsync("+965", customerData.mobile_no));
        return response.data;
      }
      
      return rejectWithValue(response.message || "Failed to update customer");
    } catch (error) {
      return rejectWithValue(error.message || "An error occurred while updating customer");
    }
  }
);
